let seaCreaturesData = [
  { key: 1011, img: "sea/NH-Icon-seaweed.png", name: "Seaweed", price: 600 },
  { key: 1012, img: "sea/Sea_grapes.png", name: "Sea Grapes", price: 900 },
  { key: 1013, img: "sea/Sea_cucumber.png", name: "Sea Cucumber", price: 500 },
  { key: 1014, img: "sea/Sea_pig.png", name: "Sea Pig", price: 8000 },
  { key: 1015, img: "sea/Sea_star.png", name: "Sea Star", price: 500 },
  { key: 1016, img: "sea/Sea_urchin.png", name: "Sea Urchin", price: 1700 },
  {
    key: 1017,
    img: "sea/Slate_pencil_urchin.png",
    name: "Slate Pencil Urchin",
    price: 2000,
  },
  { key: 1018, img: "sea/Sea_anemone.png", name: "Sea Anemone", price: 500 },
  { key: 1019, img: "sea/Moon_jellyfish.png", name: "Moon Jellyfish", price: 600 },
  { key: 10110, img: "sea/Sea_slug.png", name: "Sea Slug", price: 600 },
  { key: 10111, img: "sea/Pearl_oyster.png", name: "Pearl Oyster", price: 2800 },
  { key: 10112, img: "sea/Mussel.png", name: "Mussel", price: 1500 },
  { key: 10113, img: "sea/Oyster.png", name: "Oyster", price: 1100 },
  { key: 10114, img: "sea/Scallop.png", name: "Scallop", price: 1200 },
  { key: 10115, img: "sea/Whelk.png", name: "Whelk", price: 1000 },
  { key: 10116, img: "sea/Turban_shell.png", name: "Turban Shell", price: 1000 },
  { key: 10117, img: "sea/Abalone.png", name: "Abalone", price: 1000 },
  {
    key: 10118,
    img: "sea/Gigas_giant_clam.png",
    name: "Gigas Giant Clam",
    price: 1500,
  },
  {
    key: 10119,
    img: "sea/Chambered_nautilus.png",
    name: "Chambered Nautilus",
    price: 1800,
  },
  { key: 10120, img: "sea/Octopus.png", name: "Octopus", price: 1200 },
  {
    key: 10121,
    img: "sea/Umbrella_octopus.png",
    name: "Umbrella Octopus",
    price: 6000,
  },
  {
    key: 10122,
    img: "sea/Vampire_squid.png",
    name: "Vampire Squid",
    price: 10000,
  },
  { key: 10123, img: "sea/Firefly_squid.png", name: "Firefly Squid", price: 1400 },
  { key: 10124, img: "sea/Gazami_crab.png", name: "Gazami Crab", price: 2200 },
  {
    key: 10125,
    img: "sea/Dungeoness_crab.png",
    name: "Dungeoness Crab",
    price: 1900,
  },
  { key: 10126, img: "sea/Snow_crab.png", name: "Snow Crab", price: 6000 },
  { key: 10127, img: "sea/Red_king_crab.png", name: "Red King Crab", price: 8000 },
  {
    key: 10128,
    img: "sea/Acorn_barnicle.png",
    name: "Acorn Barnicle",
    price: 600,
  },
  { key: 10129, img: "sea/Spider_crab.png", name: "Spider Crab", price: 12000 },
  { key: 10130, img: "sea/Tiger_prawn.png", name: "Tiger Prawn", price: 3000 },
  { key: 10131, img: "sea/Sweet_shrimp.png", name: "Sweet Shrimp", price: 1400 },
  { key: 10132, img: "sea/Mantis_shrimp.png", name: "Mantis Shrimp", price: 2500 },
  { key: 10133, img: "sea/Spiny_lobster.png", name: "Spiny Lobster", price: 5000 },
  { key: 10134, img: "sea/Lobster.png", name: "Lobster", price: 5000 },
  { key: 10135, img: "sea/Giant_isopod.png", name: "Giant Isopod", price: 12000 },
  {
    key: 10136,
    img: "sea/Horseshoe_crab.png",
    name: "Horseshoe Crab",
    price: 2500,
  },
  { key: 10137, img: "sea/Sea_pineapple.png", name: "Sea Pineapple", price: 1500 },
  {
    key: 10138,
    img: "sea/Spotted_garden_eel.png",
    name: "Spotted Garden Eel",
    price: 1100,
  },
  { key: 10139, img: "sea/Flatworm.png", name: "Flatworm", price: 700 },
  {
    key: 10140,
    img: "sea/Venus_flower_basket.png",
    name: "Venus' Flower Basket",
    price: 5000,
  },
];

export default seaCreaturesData;
